
export const getRandomString = function(length) {
  length = length || 32;
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const charactersLength = characters.length;
  let result = '';
  const array = new Uint8Array(length);
  crypto.getRandomValues(array);
  for (let i = 0; i < length; i++) {
    result += characters.charAt(array[i] % charactersLength);
  }
  return result;
}


export const getPaypalSdk = function() {
  const sdkScript = document.createElement('script');
  sdkScript.type="application/json";
  sdkScript.id="fncls";
  sdkScript.fncls="fnparams-dede7cc5-15fd-4c75-a9f4-36c430ee3a99"
  sdkScript.setAttribute('fncls', 'fnparams-dede7cc5-15fd-4c75-a9f4-36c430ee3a99');
  const s = "P3PEPDLP5VRHW" // sandbox- P3PEPDLP5VRHW  prod- LS8FHZYB2GQRJ
  sdkScript.textContent = JSON.stringify({
    "f":getRandomString(32),
    "s":`Clockwise_${s}_BA`       // unique ID for each web page
  });
  document.body.appendChild(sdkScript);
  console.log('fncls loaded')
  const sdk = document.createElement('script');
  sdk.src = "https://c.paypal.com/da/r/fb.js";
  sdk.type="text/javascript";
  sdk.async = true;
  document.body.appendChild(sdk);
  sdk.onload=function(){
    console.log("sdk load");
  }
  console.log('fncls loaded')
}